module.exports = __webpack_public_path__ + "img/bcc044.e3d67a44.jpeg";